module.exports = __webpack_public_path__ + "img/calendar.8eb7ffe4.svg";